import { NgModule } from '@angular/core';
import { EpdkAppRootModule } from './ui/app-root';
import { EpdkBadgeModule } from './ui/badge';
import { EpdkConfirmationDialogModule } from './ui/confirmation-dialog';
import { EpdkErrorDialogModule } from './ui/error-dialog';
import { EpdkErrorSnackBarModule } from './ui/error-snack-bar';
import { EpdkExpandedStateModule } from './ui/expanded-state';
import { EpdkListModule } from './ui/list';
import { EpdkShimmerModule } from './ui/shimmer';
import { EpdkSideBarModule } from './ui/side-bar';
import { EpdkTabNavBarModule } from './ui/tab-nav-bar';
import { EpdkXLogoModule } from './ui/x-logo/x-logo.module';
import { ConfirmationDialogServiceModule } from './util/confirmation-dialog-service';
import { ErrorServiceModule } from './util/error-service';
import { FullscreenLoadingOverlayServiceModule } from './util/full-screen-loading-overlay-service';
import { SnackBarServiceModule } from './util/snack-bar-service/snack-bar.service.module';

@NgModule({
  imports: [
    EpdkAppRootModule,
    EpdkBadgeModule,
    EpdkErrorDialogModule,
    EpdkConfirmationDialogModule,
    EpdkErrorSnackBarModule,
    EpdkExpandedStateModule,
    EpdkListModule,
    EpdkShimmerModule,
    EpdkSideBarModule,
    EpdkTabNavBarModule,
    EpdkXLogoModule,
    ConfirmationDialogServiceModule,
    ErrorServiceModule,
    FullscreenLoadingOverlayServiceModule,
    SnackBarServiceModule
  ],
  exports: [
    EpdkAppRootModule,
    EpdkBadgeModule,
    EpdkExpandedStateModule,
    EpdkListModule,
    EpdkShimmerModule,
    EpdkSideBarModule,
    EpdkTabNavBarModule,
    EpdkXLogoModule
  ]
})
export class EpdkCommonModule { }